export default "__VITE_ASSET__CruTjy5v__"